import { Grid2, Typography } from "@mui/material";
import classNames from "classnames";
import { Link, useParams } from "react-router-dom";

import { TAccount, TChat } from "../../../../@types";
import { useAccount } from "../../../../hooks/useAccount";
import { useChat, useChatInit } from "../../../../hooks/useChat";
import useScreenSize from "../../../../hooks/useScreenSize";
import { Container } from "../../../common/Container/Container";
import noAvatarImage from "../../../imagenes/no_avatar.svg";
import { ChatBox } from "./components/ChatBox";

import "./chat.scss";

export function Chat() {
	const { width } = useScreenSize();
	const isMobile = width <= 768;
	const params = useParams();
	const userId = params.messagesUserId;
	const { account } = useAccount();
	const { listLoading, itemLoading } = useChatInit({
		chatScreen: true,
		getMessages: true,
	});
	const { chatList } = useChat();

	const getOpponent = (chatItem: TChat): TAccount | null => {
		if (chatItem.recentMessage.senderId === account?.id) {
			return chatItem.recentMessage.receiver;
		}

		if (chatItem.recentMessage.receiverId === account?.id) {
			return chatItem.recentMessage.sender;
		}

		return null;
	};

	return (
		<Container
			noFooter
			loading={listLoading}
			className="chat-content-container">
			<Grid2 container>
				{!(isMobile && userId) && (
					<Grid2
						size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
						className="chat-list">
						{chatList.map((chatItem) => {
							const opponent = getOpponent(chatItem);

							if (!opponent) {
								return null;
							}

							return (
								<Link
									key={`${chatItem.recentMessage.senderId}-${chatItem.recentMessage.receiverId}`}
									className={classNames("chat-item", {
										selected: userId === opponent.userId,
									})}
									to={`/messages/${opponent.userId}`}
									replace>
									<img
										src={
											opponent.profile?.thumbnail ||
											opponent.profile?.url ||
											noAvatarImage
										}
										className="avatar"
									/>
									<div
										style={{
											display: "flex",
											flexDirection: "column",
											flex: 1,
											position: "relative",
										}}>
										<Typography className="normal-text bold opponent-name">
											{`${opponent.firstName ?? ""} ${opponent.lastName ?? ""}`.trim()}
										</Typography>
										<Typography flex={1} className="normal-text recent-message">
											{chatItem.recentMessage.message}
										</Typography>
										{!chatItem.isRead &&
											chatItem.recentMessage.senderId === opponent.id && (
												<div className="red-dot" />
											)}
									</div>
								</Link>
							);
						})}
					</Grid2>
				)}
				{userId && (
					<Grid2
						size={{ xs: 12, sm: 12, md: 9, lg: 9, xl: 9 }}
						className="chat-box">
						<ChatBox loading={itemLoading} />
					</Grid2>
				)}
			</Grid2>
		</Container>
	);
}
